import { Controller } from "@hotwired/stimulus"

// Manages a single shared "Add to list" modal, updating the player name
// and form player_id fields dynamically when a button is clicked.
export default class extends Controller {
  static targets = ["playerName", "form"]

  open(event) {
    const { playerId, playerName } = event.currentTarget.dataset

    this.playerNameTarget.textContent = playerName
    this.formTargets.forEach((form) => {
      const input = form.querySelector(
        "input[name='list_player[player_id]'], input[name='roster_player[player_id]']"
      )
      if (input) input.value = playerId
    })

    document.getElementById("list_selector_modal").showModal()
  }

  formTargetConnected(form) {
    form.addEventListener("turbo:submit-end", this.closeModal)
  }

  formTargetDisconnected(form) {
    form.removeEventListener("turbo:submit-end", this.closeModal)
  }

  closeModal = () => {
    document.getElementById("list_selector_modal").close()
  }
}
